module.exports = __webpack_public_path__ + "img/roulotte_iode.06996d12.webp";